import { BaseService } from '@colescba/services'
import { authHeaders } from '@/util/auth.util'


import moment from 'moment'

class ArchivoService extends BaseService {
  /**
   * Crea una nueva solicitud de tipo autorizacion
   *
   * @param {import('@/model/autorizacion').Autorizacion} autorizacion
   */
  async compararArchivo(archivoBase64, archivoId) {
    const response = await this.http.post(`/archivo/compare`, {archivoBase64: archivoBase64, archivoId: archivoId})
    //const response = await this.http.post(`/archivo/compare`, {archivoBase64: archivoBase64, archivoId: archivoId}, { headers: authHeaders("20231744267")})
    return response.data
  }

  
}
export { ArchivoService }
